import { render, staticRenderFns } from "./ColorPaletteSelector.vue?vue&type=template&id=8ff0f202&scoped=true"
import script from "./ColorPaletteSelector.vue?vue&type=script&lang=js"
export * from "./ColorPaletteSelector.vue?vue&type=script&lang=js"
import style0 from "./ColorPaletteSelector.vue?vue&type=style&index=0&id=8ff0f202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff0f202",
  null
  
)

export default component.exports